import React from "react";
import styles from "./CheckBox.module.css";

const CheckBox = ({ checked }) => {
  return (
    <div className={styles.CheckBox}>
      {checked && <i class="fa-regular fa-check"></i>}
    </div>
  );
};

export default CheckBox;
